(function () {
  'use strict';

  var raices = document.querySelectorAll('[id^="ltbcf-"]');
  Array.prototype.forEach.call(raices, function (raiz) {
    var uid = raiz.id.replace('ltbcf-', '');
    var fuente = document.querySelector('[data-cf-datos="' + uid + '"]');
    if (!fuente) { return; }

    var D;
    try { D = JSON.parse(fuente.textContent); } catch (e) { return; }

    var S = { talla: null, litros: 0, largo: 0, urna: null, elegido: {}, multi: {}, cant: {}, op: {} };

    function keyDe(clave, o) { return clave + '::' + o.titulo; }

    function estDe(clave, o) {
      var k = keyDe(clave, o);
      if (!S.op[k]) { S.op[k] = { cant: 0, vid: null, sel: false }; }
      return S.op[k];
    }

    function numDe(t) {
      var m = String(t == null ? '' : t).match(/\d+/g);
      return m ? m.map(function (x) { return parseInt(x, 10); }) : [];
    }

    function rangosDe(clave, o) {
      if (o.__r) { return o.__r; }
      var vs = o.variantes || [];
      var cm = (GR[o.grupo] || {}).rango_por === 'cm';
      var r = vs.map(function (v) {
        var n = numDe(v.titulo);
        if (n.length >= 2) { return { d: n[0], h: n[1] }; }
        if (n.length === 1) { return cm ? { d: n[0], h: 0 } : { d: 0, h: n[0] }; }
        return { d: 0, h: 0 };
      });
      if (cm) {
        var solos = [];
        r.forEach(function (x, i) { if (x.d && !x.h) { solos.push(i); } });
        solos.sort(function (a, b) { return r[a].d - r[b].d; });
        solos.forEach(function (idx, k) {
          var sig = solos[k + 1];
          r[idx].h = sig != null ? (r[sig].d - 1) : 0;
        });
      }
      o.__r = r;
      return r;
    }

    function topesDe(o) {
      if (o.__t !== undefined) { return o.__t; }
      var t = null;
      String(o.topes || '').split(',').forEach(function (par) {
        var p = par.split('=');
        if (p.length !== 2) { return; }
        var k = p[0].trim();
        var n = numDe(p[1]);
        if (!k || !n.length) { return; }
        if (!t) { t = {}; }
        t[k.toLowerCase()] = n.length >= 2 ? { d: n[0], h: n[1] } : { d: 0, h: n[0] };
      });
      o.__t = t;
      return t;
    }

    function variantesValidas(clave, o) {
      var vs = o.variantes || [];
      var tp = topesDe(o);
      if (tp) {
        var mt = medidaDe(o.grupo);
        return vs.filter(function (v) {
          var x = tp[String(v.titulo == null ? '' : v.titulo).trim().toLowerCase()];
          if (!x) { return false; }
          if (!mt) { return true; }
          if (x.d && mt < x.d) { return false; }
          if (x.h && mt > x.h) { return false; }
          return true;
        });
      }
      if (!o.rango_variante || vs.length < 2) { return vs; }
      var m = medidaDe(o.grupo);
      if (!m) { return vs; }
      var r = rangosDe(clave, o);
      var ok = vs.filter(function (v, i) {
        var x = r[i] || { d: 0, h: 0 };
        if (x.d && m < x.d) { return false; }
        if (x.h && m > x.h) { return false; }
        return true;
      });
      var clava = ok.filter(function (v) {
        var x = r[vs.indexOf(v)] || { d: 0, h: 0 };
        return x.d === m;
      });
      return clava.length ? clava : ok;
    }

    function varDe(clave, o) {
      var vs = variantesValidas(clave, o);
      if (!vs.length) { return { id: o.vid, titulo: '', precio: o.precio, tope: o.tope }; }
      var e = estDe(clave, o);
      var hit = null;
      if (e.vid != null) {
        vs.forEach(function (v) { if (String(v.id) === String(e.vid)) { hit = v; } });
      }
      if (!hit) {
        vs.forEach(function (v) { if (!hit && String(v.id) === String(o.vid)) { hit = v; } });
      }
      return hit || vs[0] || { id: o.vid, titulo: '', precio: o.precio, tope: o.tope };
    }

    function precioDe(clave, o) {
      if (o.esFam) { return precioDe(clave, o.act); }
      return o.ninguna ? 0 : (varDe(clave, o).precio || 0);
    }
    function vidDe(clave, o) {
      if (o.esFam) { return vidDe(clave, o.act); }
      return o.ninguna ? 0 : varDe(clave, o).id;
    }
    function topeDeOp(clave, o) {
      if (o.esFam) { return topeDeOp(clave, o.act); }
      return o.ninguna ? 0 : (varDe(clave, o).tope || 0);
    }

    var FAM = {};

    function minimoDe(ms) {
      var mejor = null, mv = 0;
      ms.forEach(function (m) {
        var h = parseInt(m.hasta, 10) || 0;
        var v = h > 0 ? h : 1000000;
        if (!mejor || v < mv || (v === mv && (m.precio || 0) < (mejor.precio || 0))) { mejor = m; mv = v; }
      });
      return mejor;
    }

    function preparaFam(clave, fam) {
      var e = estDe(clave, fam);
      var act = null;
      if (e.mid) {
        fam.miembros.forEach(function (m) { if (m.titulo === e.mid) { act = m; } });
      }
      if (!act) {
        fam.miembros.forEach(function (m) { if (!act && m.serie) { act = m; } });
      }
      if (!act) { act = minimoDe(fam.miembros); }
      fam.act = act;
      var n = 0;
      fam.miembros.forEach(function (m) {
        n += Math.max(1, variantesValidas(clave, m).length);
      });
      fam.rotulo = n > 1 ? fam.titulo : act.titulo;
      fam.nota = act.nota; fam.img = act.img; fam.serie = act.serie; fam.valor = act.valor;
      fam.unidad = act.unidad; fam.unidad_pl = act.unidad_pl; fam.cantidades = act.cantidades;
      fam.vid = act.vid; fam.precio = act.precio;
      return fam;
    }

    function agrupaFamilias(clave, opts) {
      var out = [], vistas = {};
      opts.forEach(function (o) {
        var f = String(o.familia || '').trim();
        if (!f || o.ninguna) { out.push(o); return; }
        if (!vistas[f]) {
          var k = clave + '::fam::' + f;
          if (!FAM[k]) {
            FAM[k] = { grupo: clave, esFam: true, titulo: f, tallas: '',
              disponible: true, ninguna: false, fija: false };
          }
          FAM[k].miembros = [];
          vistas[f] = FAM[k];
          out.push(FAM[k]);
        }
        vistas[f].miembros.push(o);
      });
      out.forEach(function (x) { if (x.esFam) { preparaFam(clave, x); } });
      return out;
    }

    function etiquetaMiembro(clave, fam, m, v, varias) {
      var et = m.titulo;
      var f = String(fam.titulo || '');
      if (f && et.length > f.length && et.slice(0, f.length).toLowerCase() === f.toLowerCase()) {
        et = et.slice(f.length).replace(/^[\s\u00b7.-]+/, '') || m.titulo;
      }
      if (varias && v.titulo) { return et + ' \u00b7 ' + v.titulo; }
      var h = parseInt(m.hasta, 10) || 0;
      var dicha = numDe(et).indexOf(h) !== -1;
      if (h && !dicha && (GR[clave] || {}).rango_por !== 'cm') { et += ' \u00b7 hasta ' + h + ' L'; }
      return et;
    }

    function eleccionesDe(clave, o) {
      if (o.esFam) {
        var out = [];
        o.miembros.forEach(function (m, mi) {
          var vs = variantesValidas(clave, m);
          if (!vs.length) { vs = [{ id: m.vid, titulo: '', precio: m.precio }]; }
          var varias = vs.length > 1;
          var act = varDe(clave, m);
          vs.forEach(function (v) {
            out.push({
              val: mi + '|' + v.id,
              etq: etiquetaMiembro(clave, o, m, v, varias),
              sel: o.act === m && String(act.id) === String(v.id)
            });
          });
        });
        return out;
      }
      var a = varDe(clave, o);
      return variantesValidas(clave, o).map(function (v) {
        return { val: String(v.id), etq: v.titulo, sel: String(v.id) === String(a.id) };
      });
    }

    function nombreDe(clave, o) {
      var base = o.esFam ? o.act : o;
      var n = base.titulo;
      var vv = varDe(clave, base);
      if (variantesValidas(clave, base).length > 1 && vv.titulo) { n += ' \u00b7 ' + vv.titulo; }
      return n;
    }

    function eligeVariante(clave, o) {
      if (o.ninguna) { return false; }
      if (!o.esFam && o.fija) { return false; }
      return eleccionesDe(clave, o).length > 1;
    }

    function esMulti(clave, ul) {
      if ((ul.getAttribute('data-multi') || '').match(/true/)) { return true; }
      return conCantidad(clave);
    }

    function litrosDe(txt) {
      var m = String(txt || '').match(/\d+/);
      return m ? parseInt(m[0], 10) : 0;
    }

    var GR = {};
    (D.grupos || []).forEach(function (g) { if (g.clave) { GR[g.clave] = g; } });

    function cfgDe(clave, op) {
      var g = GR[clave] || {};
      var o = op || S.elegido[clave] || {};
      var u = o.unidad || g.unidad || '';
      return {
        unidad: u,
        unidad_pl: o.unidad ? (o.unidad_pl || o.unidad) : (g.unidad_pl || u),
        cantidades: o.cantidades || g.cantidades || ''
      };
    }

    function cantDeOp(clave, o) {
      var e = estDe(clave, o);
      var tope = topeDeOp(clave, o);
      var n = e.cant;
      if (tope > 0 && n > tope) { n = tope; }
      return n < 0 ? 0 : n;
    }

    function conCantidad(clave) {
      var g = GR[clave] || {};
      var o = S.elegido[clave] || {};
      return !!(g.con_cantidad || g.unidad || o.unidad);
    }

    function cantDeTalla(cfg) {
      var n = 1;
      String(cfg.cantidades || '').split(',').forEach(function (par) {
        var p = par.split('=');
        if (p.length === 2 && p[0].trim().toLowerCase() === S.talla) {
          var x = parseInt(p[1], 10);
          if (!isNaN(x) && x >= 0) { n = x; }
        }
      });
      return n;
    }

    function unidadDe(clave, n, op) {
      var c = cfgDe(clave, op);
      if (!c.unidad) { return ''; }
      return ' ' + (n === 1 ? c.unidad : c.unidad_pl);
    }

    function cifraDe(clave, n, op) {
      var u = unidadDe(clave, n, op);
      return u ? (n + u) : ('× ' + n);
    }

    function cantidadDe(clave) {
      if (!conCantidad(clave)) { return 1; }
      var o = S.elegido[clave];
      if (!o || o.ninguna) { return 0; }
      var n = S.cant[clave] == null ? cantDeTalla(cfgDe(clave)) : S.cant[clave];
      var tope = topeDe(clave);
      if (tope > 0 && n > tope) { n = tope; }
      return n < 0 ? 0 : n;
    }

    function esc(t) {
      return String(t == null ? '' : t)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function urlSegura(u) {
      var t = String(u == null ? '' : u).trim();
      if (!t) { return ''; }
      if (/^(https?:|mailto:|tel:)/i.test(t)) { return t; }
      if (t.charAt(0) === '/' || t.charAt(0) === '#') { return t; }
      return '';
    }

    function topeDe(clave) {
      var o = S.elegido[clave];
      return (o && o.tope) ? o.tope : 0;
    }

    function dinero(centimos) {
      var n = (centimos / 100).toFixed(2).replace('.', ',');
      return n + ' €';
    }

    function medidaDe(clave) {
      var g = GR[clave] || {};
      if (g.rango_por === 'cm') { return S.largo || 0; }
      return S.litros || 0;
    }

    function valeParaUrna(o) {
      if (o.tallas) { return valeParaTalla(o.tallas); }
      var d = parseInt(o.desde, 10) || 0;
      var h = parseInt(o.hasta, 10) || 0;
      if (!d && !h) { return true; }
      var m = medidaDe(o.grupo);
      if (!m) { return true; }
      if (d && m < d) { return false; }
      if (h && m > h) { return false; }
      return true;
    }

    function valeParaTalla(lista) {
      if (!lista) { return true; }
      var t = String(lista).split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
      if (!t.length) { return true; }
      return t.indexOf(S.talla) !== -1;
    }

    function cumpleDependencia(dep) {
      if (!dep) { return true; }
      return String(dep).split(',').every(function (par) {
        var p = par.split('=');
        if (p.length !== 2) { return true; }
        var k = p[0].trim(), v = p[1].trim();
        var el = S.elegido[k];
        return el && String(el.valor || '').toLowerCase() === v.toLowerCase();
      });
    }

    function pintaGrupos() {
      var grupos = raiz.querySelectorAll('[data-grupo]');
      Array.prototype.forEach.call(grupos, function (g) {
        var ul = g.querySelector('[data-opciones]');
        var clave = ul.getAttribute('data-opciones');
        clave = g.getAttribute('data-clave') || clave;

        var visible = S.talla !== null && cumpleDependencia(g.getAttribute('data-dep'));
        g.hidden = !visible;
        if (!visible) {
          if (S.elegido[clave]) { delete S.elegido[clave]; }
          if (S.cant[clave] != null) { delete S.cant[clave]; }
          return;
        }

        var opts = D.opciones.filter(function (o) {
          if (o.grupo !== clave || !o.disponible) { return false; }
          if (o.rango_variante && (o.variantes || []).length > 1) {
            return variantesValidas(clave, o).length > 0;
          }
          return valeParaUrna(o);
        });

        var gr = GR[clave];
        if (gr && gr.ninguna_txt) {
          opts.unshift({
            grupo: clave, tallas: '', titulo: gr.ninguna_txt, nota: '',
            vid: 0, precio: 0, img: null, serie: !!gr.ninguna_serie,
            disponible: true, tope: 0, ninguna: true, valor: '',
            unidad: '', unidad_pl: '', cantidades: ''
          });
        }

        opts = agrupaFamilias(clave, opts);

        var multi = esMulti(clave, ul);
        if (!S.elegido[clave] && !multi) {
          var serie = opts.filter(function (o) { return o.serie; })[0];
          if (serie) { S.elegido[clave] = serie; }
        }
        if (multi) {
          opts.forEach(function (o) {
            var e = estDe(clave, o);
            if (o.serie && !e.tocado) { e.tocado = true; e.sel = true; if (conCantidad(clave)) { e.cant = 1; } }
          });
        }

        var foco = null;
        if (ul.contains(document.activeElement)) {
          foco = document.activeElement.getAttribute('data-i');
        }

        var conCant = conCantidad(clave);
        ul.innerHTML = opts.map(function (o, i) {
          var e = estDe(clave, o);
          var on = multi
            ? (conCant ? cantDeOp(clave, o) > 0 : !!e.sel)
            : (S.elegido[clave] && S.elegido[clave].titulo === o.titulo);
          var pv = precioDe(clave, o);

          var tarjeta = '<button type="button" class="cf-card' + (on ? ' is-on' : '') +
            '" aria-pressed="' + (on ? 'true' : 'false') +
            '" data-clave="' + esc(clave) + '" data-i="' + i + '">' +
            (on && multi ? '<span class="cf-quita" aria-hidden="true">&times;</span>' : '') +
            (o.serie ? '<span class="cf-badge">de serie</span>' : '') +
            '<span class="cf-fig">' + (o.img ? '<img src="' + esc(o.img) + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="cf-n">' + esc(o.rotulo || o.titulo) + '</span>' +
            '<span class="cf-p">' + (o.ninguna ? 'sin coste' : dinero(pv)) + '</span>' +
            (o.nota ? '<span class="cf-x">' + esc(o.nota) + '</span>' : '') +
            '</button>';

          var sel = '';
          if (eligeVariante(clave, o)) {
            sel = '<select class="cf-var" data-var="' + esc(clave) + '" data-i="' + i + '"' +
              ' aria-label="Elige el modelo de ' + esc(o.titulo) + '">' +
              eleccionesDe(clave, o).map(function (c) {
                return '<option value="' + esc(c.val) + '"' + (c.sel ? ' selected' : '') + '>' +
                  esc(c.etq) + '</option>';
              }).join('') + '</select>';
          }

          var qty = '';
          var n = conCant && !o.ninguna ? cantDeOp(clave, o) : 0;
          if (n > 0) {
            var tp = topeDeOp(clave, o);
            var alTope = tp > 0 && n >= tp;
            qty = '<div class="cf-opq">' +
              '<button type="button" class="cf-stp" data-pasoop="' + esc(clave) + ':' + i + ':-1"' +
                ' aria-label="Quitar ' + esc(o.titulo) + '">&minus;</button>' +
              '<b>' + cifraDe(clave, n, o) + '</b>' +
              '<button type="button" class="cf-stp" data-pasoop="' + esc(clave) + ':' + i + ':1"' +
                ' aria-label="Poner ' + esc(o.titulo) + '"' + (alTope ? ' disabled' : '') + '>+</button>' +
              (alTope ? '<span class="cf-tope">' + esc(D.textos.tope || '') + '</span>' : '') +
              '<i>' + dinero(pv * n) + '</i>' +
              '</div>';
          }

          return '<li>' + tarjeta + sel + qty + '</li>';
        }).join('');

        ul.__opts = opts;
        if (foco !== null) {
          var vuelve = ul.querySelector('[data-i="' + foco + '"]');
          if (vuelve) { vuelve.focus(); }
        }
        pintaContador(g, clave);
      });
    }

    function pintaContador(g, clave) {
      var caja = g.querySelector('[data-qty]');
      if (!caja) { return; }
      var ul0 = g.querySelector('[data-opciones]');
      var el = S.elegido[clave];
      var vale = el && !el.ninguna && conCantidad(clave) && !esMulti(clave, ul0);
      caja.hidden = !vale;
      if (!vale) { return; }
      var n = cantidadDe(clave);
      var tope = topeDe(clave);
      var altope = tope > 0 && n >= tope;
      caja.innerHTML =
        '<button type="button" class="cf-stp" data-paso="' + clave + ':-1" aria-label="Quitar"' +
          (n <= 0 ? ' disabled' : '') + '>&minus;</button>' +
        '<span class="cf-qn' + (n === 0 ? ' es-cero' : '') + '">' +
          (n === 0 ? esc(D.textos.cero || '') : cifraDe(clave, n)) + '</span>' +
        '<button type="button" class="cf-stp" data-paso="' + clave + ':1" aria-label="Poner"' +
          (altope ? ' disabled' : '') + '>+</button>' +
        (altope ? '<span class="cf-tope">' + esc(D.textos.tope || '') + '</span>' : '') +
        '<span class="cf-qt">' + (n === 0 ? '&mdash;' : dinero(precioDe(clave, el) * n)) + '</span>';
    }

    function pintaFijos() {
      var caja = raiz.querySelector('[data-lista-fijos]');
      if (!caja) { return; }
      var paso = caja.closest('[data-fijos]');
      paso.hidden = S.talla === null;
      if (S.talla === null) { return; }
      var fij = D.fijos.filter(function (f) { return valeParaTalla(f.tallas); });
      caja.innerHTML = fij.map(function (f) {
        return '<div class="cf-l"><span><b>' + esc(f.titulo) + '</b>' +
          (f.nota ? '<br><small>' + esc(f.nota) + '</small>' : '') + '</span>' +
          '<span>' + dinero(f.precio) + '</span></div>';
      }).join('');
    }

    function calcula() {
      var items = [], total = 0;

      if (S.urna) {
        items.push({ n: S.urna.nombre, p: S.urna.precio, id: S.urna.vid });
        total += S.urna.precio;
      }
      Array.prototype.forEach.call(raiz.querySelectorAll('[data-grupo]'), function (g) {
        if (g.hidden) { return; }
        var ul = g.querySelector('[data-opciones]');
        var clave = g.getAttribute('data-clave') || ul.getAttribute('data-opciones');
        var multi = esMulti(clave, ul);
        var conCant = conCantidad(clave);
        var opts = ul.__opts || [];

        if (!multi) {
          var o = S.elegido[clave];
          if (!o || o.ninguna) { return; }
          var q = conCant ? cantidadDe(clave) : 1;
          if (q < 1) { return; }
          var pu = precioDe(clave, o);
          items.push({
            n: nombreDe(clave, o) + (conCant ? ' · ' + cifraDe(clave, q, o) : ''),
            p: pu * q, id: vidDe(clave, o), q: q
          });
          total += pu * q;
          return;
        }

        opts.forEach(function (o) {
          if (o.ninguna) { return; }
          var e = estDe(clave, o);
          var q = conCant ? cantDeOp(clave, o) : (e.sel ? 1 : 0);
          if (q < 1) { return; }
          var pu = precioDe(clave, o);
          var nom = nombreDe(clave, o);
          if (conCant) { nom += ' · ' + cifraDe(clave, q, o); }
          items.push({ n: nom, p: pu * q, id: vidDe(clave, o), q: q, extra: !conCant });
          total += pu * q;
        });
      });
      if (S.talla !== null) {
        D.fijos.filter(function (f) { return valeParaTalla(f.tallas); })
          .forEach(function (f) { items.push({ n: f.titulo, p: f.precio, id: f.vid }); total += f.precio; });
      }
      var lista = raiz.querySelector('[data-lista]');
      lista.innerHTML = items.map(function (x) {
        return '<li' + (x.extra ? ' class="is-extra"' : '') + '><span>' + esc(x.n) + '</span><span>' + dinero(x.p) + '</span></li>';
      }).join('');
      raiz.querySelector('[data-vacio]').hidden = items.length > 0;
      raiz.querySelector('[data-n]').textContent = items.length;
      raiz.querySelector('[data-total]').textContent = items.length ? dinero(total) : '—';

      var faltan = false;
      Array.prototype.forEach.call(raiz.querySelectorAll('[data-grupo]'), function (g) {
        if (g.hidden) { return; }
        var ul = g.querySelector('[data-opciones]');
        var clave = g.getAttribute('data-clave');
        if (esMulti(clave, ul)) { return; }
        if (!S.elegido[clave]) { faltan = true; }
      });

      var listo = S.urna !== null && !faltan;
      var compra = items.filter(function (x) { return x.id; });
      var botones = raiz.querySelectorAll('[data-add], [data-add-movil]');
      Array.prototype.forEach.call(botones, function (btn) {
        btn.disabled = !listo;
        btn.textContent = listo ? D.textos.add : D.textos.incompleto;
        btn.__items = compra;
      });

      var barra = raiz.querySelector('[data-barra]');
      if (barra) {
        barra.hidden = items.length === 0;
        var tm = barra.querySelector('[data-total-movil]');
        if (tm) { tm.textContent = items.length ? dinero(total) : '—'; }
      }

      pintaEquivalencia(listo);
    }

    function pintaEquivalencia(listo) {
      var caja = raiz.querySelector('[data-nivel]');
      caja.hidden = true;
      if (!listo || !D.equivalencias.length) { return; }
      var eq = D.equivalencias.filter(function (e) {
        if (!e.combina) { return false; }
        return String(e.combina).split(',').every(function (par) {
          var p = par.split('='); if (p.length !== 2) { return false; }
          var el = S.elegido[p[0].trim()];
          return el && String(el.valor || '').toLowerCase() === p[1].trim().toLowerCase();
        });
      })[0];
      if (!eq) { return; }
      caja.hidden = false;
      var u = urlSegura(eq.url);
      caja.innerHTML = u
        ? '<a href="' + esc(u) + '">' + esc(eq.texto) + '</a>'
        : esc(eq.texto);
    }

    function pinta() { pintaGrupos(); pintaGrupos(); pintaFijos(); calcula(); }

    raiz.addEventListener('change', function (e) {
      var sv = e.target.closest('[data-var]');
      if (!sv) { return; }
      var clave = sv.getAttribute('data-var');
      var ul = sv.closest('[data-opciones]');
      var o = (ul.__opts || [])[+sv.getAttribute('data-i')];
      if (!o) { return; }
      if (o.esFam) {
        var par = String(sv.value).split('|');
        var m = o.miembros[+par[0]];
        if (m) { estDe(clave, o).mid = m.titulo; estDe(clave, m).vid = par[1]; }
      } else {
        estDe(clave, o).vid = sv.value;
      }
      pinta();
    });

    raiz.addEventListener('click', function (e) {
      var sp = e.target.closest('[data-pasoop]');
      if (sp) {
        var q = sp.getAttribute('data-pasoop').split(':');
        var cl = q[0], idx = +q[1], d = parseInt(q[2], 10);
        var ul2 = sp.closest('[data-opciones]');
        var op = (ul2.__opts || [])[idx];
        if (!op) { return; }
        var est = estDe(cl, op);
        var mx = topeDeOp(cl, op);
        mx = mx > 0 ? Math.min(mx, 99) : 99;
        est.cant = Math.max(0, Math.min(mx, cantDeOp(cl, op) + d));
        est.tocado = true;
        est.sel = est.cant > 0;
        pinta();
        return;
      }

      var st = e.target.closest('[data-paso]');
      if (st) {
        var pr = st.getAttribute('data-paso').split(':');
        var cl = pr[0], d = parseInt(pr[1], 10);
        var act = cantidadDe(cl);
        var max = topeDe(cl);
        max = max > 0 ? Math.min(max, 99) : 99;
        S.cant[cl] = Math.max(0, Math.min(max, act + d));
        pinta();
        return;
      }
      var b = e.target.closest('.cf-card');
      if (!b) { return; }

      if (b.getAttribute('data-tipo') === 'urna') {
        S.talla = (b.getAttribute('data-talla') || '').toLowerCase();
        S.litros = parseInt(b.getAttribute('data-litros'), 10) || litrosDe(S.talla);
        S.largo = parseInt(b.getAttribute('data-largo'), 10) || 0;
        S.urna = {
          nombre: b.getAttribute('data-nombre'),
          precio: parseInt(b.getAttribute('data-precio'), 10) || 0,
          vid: b.getAttribute('data-vid')
        };
        S.elegido = {}; S.multi = {}; S.cant = {}; S.op = {};
        Array.prototype.forEach.call(raiz.querySelectorAll('[data-tipo="urna"]'), function (x) {
          x.classList.toggle('is-on', x === b);
        });
        pinta();
        return;
      }

      var clave = b.getAttribute('data-clave');
      var ul = b.closest('[data-opciones]');
      var o = ul.__opts[+b.getAttribute('data-i')];
      if (!o) { return; }

      if (esMulti(clave, ul)) {
        var est2 = estDe(clave, o);
        est2.tocado = true;
        if (conCantidad(clave)) {
          est2.cant = cantDeOp(clave, o) > 0 ? 0 : 1;
          est2.sel = est2.cant > 0;
        } else {
          est2.sel = !est2.sel;
        }
      } else {
        S.elegido[clave] = o;
        delete S.cant[clave];
      }
      pinta();
    });

    Array.prototype.forEach.call(raiz.querySelectorAll('[data-add], [data-add-movil]'), function (b0) {
      b0.addEventListener('click', alCarrito);
    });

    function alCarrito() {
      var btn = this;
      var items = (btn.__items || []).map(function (x) { return { id: x.id, quantity: x.q || 1 }; });
      if (!items.length) { return; }
      var antes = btn.textContent;
      var prev = raiz.querySelector('[data-fallo]');
      if (prev) { prev.hidden = true; }
      btn.disabled = true;
      btn.textContent = D.textos.anadiendo;

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (j) {
            if (!r.ok) { throw new Error(j.description || j.message || ''); }
            return j;
          });
        })
        .then(function () { window.location.href = '/cart'; })
        .catch(function (err) {
          btn.disabled = false;
          btn.textContent = D.textos.error;
          var aviso = raiz.querySelector('[data-fallo]');
          if (aviso) {
            aviso.textContent = (err && err.message) ? err.message : D.textos.error;
            aviso.hidden = false;
          }
          setTimeout(function () { btn.textContent = antes; btn.disabled = false; }, 4000);
        });
    }

    pinta();
  });
})();
